import React from "react";
import { IconTypes } from "./types";

export default function UsersIcon({
  fill = "white",
  height = "35",
  width = "35",
}: Partial<IconTypes>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 52 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.638 19.345C14.097 19.345 16.9107 16.5309 16.9107 13.072C16.9107 9.61312 14.0966 6.79932 10.638 6.79932C7.17979 6.79932 4.36499 9.61302 4.36499 13.072C4.36499 16.531 7.17909 19.345 10.638 19.345ZM10.638 9.43882C12.6415 9.43882 14.2712 11.0685 14.2712 13.072C14.2712 15.0755 12.6415 16.7052 10.638 16.7052C8.63449 16.7052 7.00479 15.0751 7.00479 13.072C7.00479 11.0689 8.63449 9.43882 10.638 9.43882Z"
        fill={fill}
      />
      <path
        d="M3.43996 28.5761C3.43996 25.8808 5.63256 23.6886 8.32746 23.6886H12.9482C13.0864 23.6886 13.2235 23.6941 13.3591 23.7058C13.7415 23.739 14.1212 23.6105 14.3989 23.3554C14.6692 23.1062 14.8188 22.7656 14.8188 22.3969C14.8188 21.7238 14.3036 21.1465 13.645 21.0832C13.4153 21.0613 13.1829 21.0496 12.9478 21.0496H8.32705C4.17705 21.0484 0.800049 24.4254 0.800049 28.5762V29.1187H3.43985L3.43996 28.5761Z"
        fill={fill}
      />
      <path
        d="M15.287 29.118H17.9268V25.8684C17.9268 22.8219 20.4053 20.3434 23.4522 20.3434H28.5475C31.594 20.3434 34.0729 22.8219 34.0729 25.8684V29.118H36.7127V25.8684C36.7127 23.1125 35.3291 20.5594 33.0111 19.0399C31.6783 18.1657 30.1349 17.7036 28.5478 17.7036H23.4525C20.9306 17.7036 18.5873 18.8516 17.0224 20.8532C15.8872 22.3052 15.2876 24.0395 15.2876 25.8684L15.288 29.118H15.287Z"
        fill={fill}
      />
      <path
        d="M43.6729 21.0481H39.0522C38.9229 21.0481 38.7948 21.052 38.6671 21.0586C37.9554 21.0977 37.3976 21.6786 37.3976 22.3813C37.3976 22.7442 37.5484 23.0942 37.8113 23.3423C38.0761 23.5915 38.4226 23.7165 38.7835 23.6958C38.8726 23.6903 38.962 23.688 39.0523 23.688H43.673C46.3683 23.688 48.5605 25.8806 48.5605 28.5755V29.1181L51.2003 29.1185V28.5759C51.2003 24.4251 47.8233 21.0482 43.673 21.0482L43.6729 21.0481Z"
        fill={fill}
      />
      <path
        d="M41.3619 19.345C44.8209 19.345 47.6349 16.5309 47.6349 13.072C47.6349 9.61312 44.8208 6.79932 41.3619 6.79932C37.9026 6.79932 35.0886 9.61302 35.0886 13.072C35.0886 16.531 37.9034 19.345 41.3619 19.345ZM41.3619 9.43882C43.3654 9.43882 44.9951 11.0685 44.9951 13.072C44.9951 15.0755 43.365 16.7052 41.3619 16.7052C39.3589 16.7052 37.7288 15.0751 37.7288 13.072C37.7284 11.0689 39.3589 9.43882 41.3619 9.43882Z"
        fill={fill}
      />
      <path
        d="M26 16.6641C30.3508 16.6641 33.891 13.1243 33.891 8.77308C33.891 4.42188 30.3512 0.88208 26 0.88208C21.6488 0.88208 18.109 4.42188 18.109 8.77308C18.109 13.1239 21.6488 16.6641 26 16.6641ZM26 3.52108C28.8953 3.52108 31.2512 5.87698 31.2512 8.77268C31.2512 11.668 28.8953 14.0239 26 14.0239C23.1043 14.0239 20.7484 11.668 20.7484 8.77268C20.7484 5.87698 23.1043 3.52108 26 3.52108Z"
        fill={fill}
      />
    </svg>
  );
}
